import { Dispatch, ReducerState, ReducerAction, createContext } from "react";
import PopUpsReducer from "./pop-up.reducer";

type PopUpReducerState = ReducerState<typeof PopUpsReducer>;
type PopUpDispatchAction = Dispatch<ReducerAction<typeof PopUpsReducer>>;
type PopUpContextType = [PopUpReducerState, PopUpDispatchAction];

export const PopUpContext = createContext<PopUpContextType>([{ popUp: null }, (state) => state]);
